'use client';

import clsx from 'clsx';
import type { StatCardProps } from './types';

export default function StatCard({ value, label, className, classNames = {} }: StatCardProps) {
    const root = classNames.root ?? 'stat-card';
    const valueClass = classNames.value ?? 'stat-card__value';
    const labelClass = classNames.label ?? 'stat-card__label';
    return (
        <div className={clsx(root, className)}>
            <div className={clsx(valueClass)}>{value}</div>
            <div className={clsx(labelClass)}>{label}</div>
        </div>
    );
}
